import { useGetDivisionList } from '../../screens/Claims/LossAndDamage/hooks';
import FormSelectBox from '../Inputs/FormSelectBox';

const LADClaimsDivisionSelector = ({
  placeholder = 'Select Division',
  label = 'Division',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  mode = '',
  disableValidation = false,
}) => {
  const { data: options = [], isLoading } = useGetDivisionList();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
    />
  );
};

export default LADClaimsDivisionSelector;
